import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'click', () => {
            this.el.classList.add( 'loading' );
            axios.get( THEME_OBJ.ajaxURL + '?action=submit-for-review').then( (response) => {
                this.el.classList.remove( 'loading' );
                if( response.data.success ){
                    this.el.closest( '.submit-profile' ).classList.add( 'success' );
                    this.el.remove();
                }
            }).catch( e => {});
        });

    }
    init() {}
    destroy(){}
}
